import { useState, useMemo } from "react";
import { Plus } from "lucide-react";
import { MobileDrawerNav } from "@/components/layout/MobileDrawerNav";
import { CreateSiteDialog } from "@/components/CreateSiteDialog";
import { useSitesWithKPIs } from "@/hooks/useSitesWithKPIs";
import { COMPANY_SIDEBAR_NAV } from "@/config/navigation";

export function CompanyDrawerNav() {
  const [isCreateDialogOpen, setIsCreateDialogOpen] = useState(false);
  const { refetch } = useSitesWithKPIs();

  const ctas = useMemo(
    () => [
      {
        icon: Plus,
        label: "Nouveau chantier",
        onClick: () => setIsCreateDialogOpen(true),
      },
    ],
    [],
  );

  return (
    <>
      <MobileDrawerNav
        navItems={COMPANY_SIDEBAR_NAV}
        ctas={ctas}
        settingsPath="/settings"
      />
      <CreateSiteDialog
        open={isCreateDialogOpen}
        onOpenChange={setIsCreateDialogOpen}
        onSuccess={() => {
          refetch();
          setIsCreateDialogOpen(false);
        }}
      />
    </>
  );
}
